import ModuleAccessService from "@/services/access-module.service";

export const getRights = () => {
  if (!ModuleAccessService.getDepartmentCode()) {
    return { rights: "read_only", access: null };
  } else {
    if (ModuleAccessService.getDepartmentCode() == "AUD") {
      return { rights: "read_only", dept_code: "AUD", access: null };
    } else if (ModuleAccessService.getDepartmentCode() == "ACC") {
      return { rights: "read_only", dept_code: "ACC", access: null };
    } else if (ModuleAccessService.getDepartmentCode() == "ADM") {
      return {
        rights: "editor",
        dept_code: ModuleAccessService.getDepartmentCode(),
        access: null
      };
    } else if (ModuleAccessService.getDepartmentCode() == "ITD") {
      return {
        rights: "administrator",
        dept_code: ModuleAccessService.getDepartmentCode(),
        access: null
      };
    } else {
      return { rights: "read_only", dept_code: "", access: null };
    }
  }
};

export const getAccessPermission = () => {
  const user_role = ModuleAccessService.getRole();
  if (!user_role) {
    return { rights: "read_only" };
  } else {
    return { rights: user_role };
  }
};

export default { getRights, getAccessPermission };
